<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>设备物流</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      :page.sync="page"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      @refresh-change="refreshChange"
      @on-load="onLoad"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot-scope="scope" slot="menu">
        <el-button v-if="scope.row.status === 0" type="text" size="small" @click="openDispatch(scope.row)">发货</el-button>
        <el-button v-if="scope.row.status === 3" type="text" size="small" @click="confirmReceive(scope.row)">确认收货</el-button>
        <el-button v-if="scope.row.status === 4" type="text" size="small" @click="startDetect(scope.row)">开始检测</el-button>
        <el-button v-if="scope.row.status === 5" type="text" size="small" @click="openAudit(scope.row)">审核</el-button>
        <el-button type="text" size="small" @click="openDetail(scope.row)">查看</el-button>
      </template>
    </avue-crud>

    <!-- 发货弹窗 -->
    <el-dialog title="设备发货" :visible.sync="dispatchVisible" width="500px">
      <el-form :model="dispatchForm" label-width="100px">
        <el-form-item label="订单ID">
          <el-input v-model="dispatchForm.orderId" disabled />
        </el-form-item>
        <el-form-item label="快递单号" required>
          <el-input v-model="dispatchForm.expressNo" placeholder="请输入快递单号" clearable />
        </el-form-item>
        <el-form-item label="快递公司" required>
          <el-input v-model="dispatchForm.expressCompany" placeholder="如：顺丰" clearable />
        </el-form-item>
        <el-form-item label="设备SN码">
          <el-input v-model="dispatchForm.deviceSn" placeholder="多个用/隔开" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dispatchVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDispatch" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog title="设备审核" :visible.sync="auditVisible" width="500px">
      <el-form :model="auditForm" label-width="100px">
        <el-form-item label="订单ID">
          <el-input v-model="auditForm.orderId" disabled />
        </el-form-item>
        <el-form-item label="审核结果" required>
          <el-radio-group v-model="auditForm.pass">
            <el-radio :label="true">通过</el-radio>
            <el-radio :label="false">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="驳回原因" v-if="auditForm.pass === false">
          <el-input v-model="auditForm.rejectReason" type="textarea" :rows="3" placeholder="请输入驳回原因" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="设备详情" :visible.sync="detailVisible" width="600px">
      <el-form :model="detailForm" label-width="120px">
        <el-form-item label="订单ID"><span>{{ detailForm.orderId }}</span></el-form-item>
        <el-form-item label="用户ID"><span>{{ detailForm.wxUserId }}</span></el-form-item>
        <el-form-item label="设备SN"><span>{{ detailForm.deviceSn || '-' }}</span></el-form-item>
        <el-form-item label="寄出快递"><span>{{ detailForm.sendExpressCompany }} {{ detailForm.sendExpressNo }}</span></el-form-item>
        <el-form-item label="寄回快递"><span>{{ detailForm.returnExpressCompany }} {{ detailForm.returnExpressNo || '-' }}</span></el-form-item>
        <el-form-item label="状态"><span>{{ statusText(detailForm.status) }}</span></el-form-item>
        <el-form-item label="驳回原因" v-if="detailForm.rejectReason">
          <span style="color: #f56c6c">{{ detailForm.rejectReason }}</span>
        </el-form-item>
        <el-form-item label="创建时间"><span>{{ detailForm.createTime }}</span></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getDeviceList,
  dispatchDevice,
  confirmPlatformReceive,
  startDetect,
  auditDevice
} from "@/api/healthmanagement/deviceManage";

const statusDic = [
  { label: "待发货", value: 0 },
  { label: "已发货", value: 1 },
  { label: "已收货", value: 2 },
  { label: "申请退还中", value: 3 },
  { label: "平台收货中", value: 4 },
  { label: "检测中", value: 5 },
  { label: "审核通过", value: 6 },
  { label: "审核驳回", value: 7 }
];

export default {
  data() {
    return {
      form: {},
      data: [],
      page: { pageSize: 10, currentPage: 1, total: 0 },
      headerCellClassName: "headerClass",
      submitting: false,

      dispatchVisible: false,
      dispatchForm: { orderId: "", expressNo: "", expressCompany: "", deviceSn: "" },

      auditVisible: false,
      auditForm: { orderId: "", pass: true, rejectReason: "" },

      detailVisible: false,
      detailForm: {},

      option: {
        tip: false,
        border: true,
        index: true,
        indexLabel: "序号",
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        selection: false,
        menuWidth: 240,
        searchMenuSpan: 5,
        column: [
          { label: "订单ID", prop: "orderId", search: true, overHidden: true },
          { label: "用户ID", prop: "wxUserId", overHidden: true },
          { label: "设备SN", prop: "deviceSn" },
          {
            label: "寄出快递",
            prop: "sendExpressNo",
            formatter: row => !row.sendExpressNo ? "-" : (row.sendExpressCompany || "") + " " + row.sendExpressNo
          },
          {
            label: "寄回快递",
            prop: "returnExpressNo",
            formatter: row => !row.returnExpressNo ? "-" : (row.returnExpressCompany || "") + " " + row.returnExpressNo
          },
          { label: "状态", prop: "status", type: "select", dicData: statusDic },
          { label: "驳回原因", prop: "rejectReason", overHidden: true },
          { label: "创建时间", prop: "createTime", }
        ]
      }
    };
  },

  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return { addBtn: false, viewBtn: false, delBtn: false, editBtn: false };
    }
  },

  methods: {
    onLoad(page, params = {}) {
      getDeviceList(page.currentPage, page.pageSize, params).then(res => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records || [];
      });
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    statusText(status) {
      const item = statusDic.find(d => d.value === status);
      return item ? item.label : "未知";
    },

    openDispatch(row) {
      this.dispatchForm = { orderId: row.orderId, expressNo: "", expressCompany: "", deviceSn: "" };
      this.dispatchVisible = true;
    },

    submitDispatch() {
      if (!this.dispatchForm.expressNo) { this.$message.warning("请输入快递单号"); return; }
      if (!this.dispatchForm.expressCompany) { this.$message.warning("请输入快递公司"); return; }

      this.submitting = true;
      dispatchDevice(this.dispatchForm).then(res => {
        this.submitting = false;
        if (res.success !== false) {
          this.$message.success("发货成功");
          this.dispatchVisible = false;
          this.onLoad(this.page);
        } else {
          this.$message.error(res.msg || "发货失败");
        }
      }).catch(() => { this.submitting = false; });
    },

    confirmReceive(row) {
      this.$confirm("确认已收到用户寄回的设备？", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning"
      }).then(() => confirmPlatformReceive(row.orderId))
        .then(res => {
          if (res.success !== false) {
            this.$message.success("操作成功")
            this.onLoad(this.page)
          } else {
            this.$message.error(res.msg || "操作失败")
          }
        }).catch(() => {});
    },

    startDetect(row) {
      this.$confirm("开始检测该设备？", "提示", {
        confirmButtonText: "确定", cancelButtonText: "取消", type: "warning"
      }).then(() => startDetect(row.orderId))
        .then(res => {
          if (res.success !== false) {
            this.$message.success("操作成功")
            this.onLoad(this.page)
          } else {
            this.$message.error(res.msg || "操作失败")
          }
      }).catch(() => {});
    },

    openAudit(row) {
      this.auditForm = { orderId: row.orderId, pass: true, rejectReason: "" };
      this.auditVisible = true;
    },

    submitAudit() {
      if (this.auditForm.pass === false && !this.auditForm.rejectReason) {
        this.$message.warning("请输入驳回原因");
        return;
      }

      this.submitting = true;
      auditDevice(this.auditForm).then(res => {
        this.submitting = false;
        if (res.success !== false) {
          this.$message.success("审核成功");
          this.auditVisible = false;
          this.onLoad(this.page);
        } else {
          this.$message.error(res.msg || "审核失败");
        }
      }).catch(() => { this.submitting = false; });
    },

    openDetail(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    }
  }
};
</script>

<style scoped>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
